import { secureTokenStorage, migrateLegacyTokens } from '../utils/secureTokenStorage';

export const SESSION_MODEL_VERSION = '3.0';
const VERSION_KEY = 'session_model_version';
const AUTH_REDIRECT_MESSAGE_KEY = 'auth_redirect_message';

export type SessionMigrationResult = {
  migrated: boolean;
  requiresLogin: boolean;
  message?: string;
};

export function setAuthRedirectMessage(message: string): void {
  try {
    sessionStorage.setItem(AUTH_REDIRECT_MESSAGE_KEY, message);
  } catch {
    // ignore
  }
}

export function consumeAuthRedirectMessage(): string | null {
  try {
    const message = sessionStorage.getItem(AUTH_REDIRECT_MESSAGE_KEY);
    if (message) {
      sessionStorage.removeItem(AUTH_REDIRECT_MESSAGE_KEY);
    }
    return message;
  } catch {
    return null;
  }
}

/**
 * App 启动：迁移至 Access 单 Token 会话模型（清除 refreshToken 等旧数据；
 * accessToken 持久化在 localStorage，见 migrateLegacyTokens）
 */
export function runSessionMigration(): SessionMigrationResult {
  const hadLegacyTokens =
    Boolean(localStorage.getItem('token')) ||
    Boolean(localStorage.getItem('refreshToken'));

  migrateLegacyTokens();

  const storedVersion = localStorage.getItem(VERSION_KEY);
  const hadAnyToken = hadLegacyTokens || secureTokenStorage.hasAccessToken();
  const needsMigration = storedVersion !== SESSION_MODEL_VERSION;

  if (needsMigration) {
    secureTokenStorage.clearTokens();
    localStorage.removeItem('user');
    localStorage.setItem(VERSION_KEY, SESSION_MODEL_VERSION);

    if (hadAnyToken) {
      const message = '会话模型已升级，请重新登录';
      setAuthRedirectMessage(message);
      return { migrated: true, requiresLogin: true, message };
    }

    return { migrated: true, requiresLogin: false };
  }

  return { migrated: false, requiresLogin: false };
}
